import { Component, ViewChild, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { GenerateReportComponent } from './pages/generate-report/generate-report.component';

@Component({
  selector: 'app-daily-report',
  templateUrl: './daily-report.component.html',
  styleUrls: ['./daily-report.component.scss'],
})
export class DailyReportComponent {
  @ViewChild('generateReports') GenerateReportComponent!: GenerateReportComponent;
  selectedTab: boolean = true;
  constructor() {}
  ngOnInit() {
    this.selectedTab = true;
  }
  tabChanged(event: MatTabChangeEvent) {
    this.selectedTab = !this.selectedTab;
    if (this.GenerateReportComponent) {
      this.GenerateReportComponent.refresh();
    }
  }
}
